module.exports = __webpack_public_path__ + "img/root-98.38c5846a.png";